import Customers from "~/pages/dashboard/Customers.vue";
import Relations from "~/pages/dashboard/Relations.vue";
import Leads from "~/pages/dashboard/Leads.vue";
import Tasks from "~/pages/dashboard/Tasks.vue";
import Calendar from "~/pages/dashboard/Calendar.vue";
import Reporting from "~/pages/dashboard/Reporting.vue";
import Selections from "~/pages/dashboard/Selections.vue";
import Tools from "~/pages/dashboard/Tools.vue";
import Campaigns from "~/pages/dashboard/Campaigns.vue";
import Signals from "~/pages/dashboard/Signals.vue";
import Index from "~/pages/tasks/task_lists/Index.vue";
import Create from "~/pages/tasks/task_lists/Create.vue";

export default [
  {
    path: "",
    component: Customers,
    name: "dashboard.index",
  },
  {
    path: "/customers",
    component: Customers,
    name: "customers.index",
  },
  {
    path: "/relations",
    component: Relations,
    name: "relations.index",
  },
  {
    path: "/leads",
    component: Leads,
    name: "leads.index",
  },
  {
    path: "/tasks",
    component: Tasks,
    name: "tasks.index",
  },
  {
    path: "/calendar",
    component: Calendar,
    name: "calendar.index",
  },
  {
    path: "/reporting",
    component: Reporting,
    name: "reporting.index",
  },
  {
    path: "/selections",
    component: Selections,
    name: "selections.index",
  },
  {
    path: "/tools",
    component: Tools,
    name: "tools.index",
  },
  {
    path: "/campaigns",
    component: Campaigns,
    name: "campaigns.index",
  },
  {
    path: "/signals",
    component: Signals,
    name: "signals.index",
  },
  {
    path: "/taskLists",
    component: Index,
    name: "task_lists.index",
  },
  {
    path: "/taskLists/create",
    component: Create,
    name: "task_lists.create",
  },
];
